export default __webpack_public_path__ + "static/media/teacher2.f9c2f94a.jpg";